// Money fields (unit_price, step_price, base_price, billable_step_price_sum)
// arrive as decimal strings and stay strings — no float math on money.

export class InvoiceLineItem {
  trace_id: number;
  billing_date: string;
  as_of: string | null;
  create_date: string;
  consumer_id: number;
  engagement_id: number;
  engagement_name: string;
  contract_id: number;
  contract_name: string;
  population_segment_id: number | null;
  population_segment_name: string | null;
  journey_step_id: number;
  journey_step_name: string;
  journey_step_sequence: number;
  dimension_code: string | null;
  dimension_name: string | null;
  pricesheet_item_id: number | null;
  pricesheet_item_name: string | null;
  unit_price: string | null;
  step_price: string | null;
  base_price: string | null;
  price: string | null;
  is_preconvert: boolean;
  is_reversion: boolean;
  is_reconvert: boolean;
  is_control: boolean;
  billable: boolean;

  constructor(data: any) {
    this.trace_id = data.trace_id;
    this.billing_date = data.billing_date;
    this.as_of = data.as_of ?? null;
    this.create_date = data.create_date;
    this.consumer_id = data.consumer_id;
    this.engagement_id = data.engagement_id;
    this.engagement_name = data.engagement_name ?? "";
    this.contract_id = data.contract_id;
    this.contract_name = data.contract_name ?? "";
    this.population_segment_id = data.population_segment_id ?? null;
    this.population_segment_name = data.population_segment_name ?? null;
    this.journey_step_id = data.journey_step_id;
    this.journey_step_name = data.journey_step_name ?? "";
    this.journey_step_sequence = data.journey_step_sequence;
    this.dimension_code = data.dimension_code ?? null;
    this.dimension_name = data.dimension_name ?? null;
    this.pricesheet_item_id = data.pricesheet_item_id ?? null;
    this.pricesheet_item_name = data.pricesheet_item_name ?? null;
    this.unit_price = data.unit_price ?? null;
    this.step_price = data.step_price ?? null;
    this.base_price = data.base_price ?? null;
    this.price = data.price ?? null;
    this.is_preconvert = data.is_preconvert ?? false;
    this.is_reversion = data.is_reversion ?? false;
    this.is_reconvert = data.is_reconvert ?? false;
    this.is_control = data.is_control ?? false;
    this.billable = data.billable ?? false;
  }
}

export class InvoiceTotals {
  line_items: number;
  conversions: number;
  reversions: number;
  reconverts: number;
  preconverts: number;
  control: number;
  billable: number;
  billable_total: string;

  constructor(data: any) {
    this.line_items = data?.line_items ?? 0;
    this.conversions = data?.conversions ?? 0;
    this.reversions = data?.reversions ?? 0;
    this.reconverts = data?.reconverts ?? 0;
    this.preconverts = data?.preconverts ?? 0;
    this.control = data?.control ?? 0;
    this.billable = data?.billable ?? 0;
    this.billable_total = data?.billable_total ?? "0.00";
  }
}

export class Invoice {
  organization_id: number;
  organization_name: string;
  start: string | null;
  end: string | null;
  totals: InvoiceTotals;
  warnings: readonly string[];
  line_items: InvoiceLineItem[];

  constructor(data: any) {
    this.organization_id = data.organization_id;
    this.organization_name = data.organization_name ?? "";
    this.start = data.start ?? null;
    this.end = data.end ?? null;
    this.totals = new InvoiceTotals(data.totals);
    this.warnings = data.warnings ?? [];
    this.line_items = (data.line_items ?? []).map((item: any) => new InvoiceLineItem(item));
  }
}
